import React from 'react';

export default class RestaurantsLoading extends React.PureComponent {
  render() {
    return (
      <div>
        <div
          className="rest-breadcrumb white-bg d-flex justify-content-between align-items-center"
          style={{ marginTop: '-57px', marginBottom: '10px', height: '50px' }}
        >
          <p
            className="spinner-element animate"
            style={{ width: '43px', height: '16px' }}
          />
          <p
            className="spinner-element animate"
            style={{ width: '88px', height: '16px' }}
          />
          <p
            className="spinner-element animate"
            style={{ width: '43px', height: '16px' }}
          />
        </div>
        <div className="rest-breadcrumb white-bg d-flex justify-content-between align-items-center visible-xs">
          <p
            className="spinner-element animate"
            style={{ width: '100px', height: '10px' }}
          />
          <p
            className="spinner-element animate"
            style={{ width: '50px', height: '10px' }}
          />
        </div>

        <div className="hide-xs">
          <div className="row rest-breadcrumb white-bg">
            <div className="col-sm-4 left">
              <a href="javascript: void(0)">
                <p
                  className="spinner-element animate"
                  style={{
                    width: '64px',
                    height: '16px',
                    marginBottom: '10px',
                  }}
                />
                <p
                  className="spinner-element animate"
                  style={{ width: '167px', height: '16px' }}
                />
              </a>
            </div>
            <div className="col-sm-8 right d-flex align-items-center">
              <div className="form">
                <input type="text" className="form-input" />
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ position: 'absolute', width: '100%', top: '18px' }}
                >
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '167px',
                      height: '16px',
                      marginLeft: '20px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '23px',
                      height: '16px',
                      marginRight: '30px',
                    }}
                  />
                </div>
              </div>
              <div>
                <a
                  href="javascript:void(0)"
                  className="d-flex align-items-center "
                >
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '23px',
                      height: '23px',
                      marginRight: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{ width: '95px', height: '16px' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="restaurant-list row">
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="items">
              <div
                className="spinner-element animate img"
                style={{ width: '100%', height: '140px', marginBottom: '20px' }}
              >
                <p className="avg-score">
                  <span
                    className="spinner-element animate"
                    style={{ display: 'block', width: '27px', height: '27px' }}
                  />
                </p>
              </div>
              <div>
                <div
                  className="spinner-element animate"
                  style={{
                    width: '80px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div
                  className="spinner-element animate"
                  style={{
                    width: '65px',
                    height: '10px',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                />
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '50px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                    }}
                  />
                  <p
                    className="spinner-element animate"
                    style={{
                      width: '25px',
                      height: '10px',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      marginRight: '10px',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
